export const TABLE_ADDED_TYPE = Symbol('added');
export const TABLE_EDIT_TYPE = Symbol('edit');
